import { connect } from 'react-redux';

import {
  updateNotificationManager,
  loadNotificationsTypes,
  loadNotificationsChannels,
  loadNotificationsSettings,
  updateNotificationChannel,
  setContextualSupport,
  unsetContextualSupport,
} from '../../actions';

import { getCurrentUser } from '../../reducers/selectors';

import NotificationsManager from './NotificationsManager';
import {
  GET_NOTIFICATIONS_CHANNEL_REQUEST,
  GET_NOTIFICATIONS_SETTINGS_REQUEST,
} from 'js/constants/actionTypes';

const mapStateToProps = (state) => {
  const {
    notificationsManager,
    request,
    entities: { notificationChannels },
  } = state;
  const loadingChannelUpdate = request.UPDATE_NOTIFICATIONS_CHANNEL_REQUEST;
  const { notification_channels_enum_map, channelActionType } = notificationsManager;
  // Slack
  const slackChannelId = notification_channels_enum_map && notification_channels_enum_map.SLACK;
  const slackChannelURL =
    slackChannelId &&
    notificationChannels[slackChannelId] &&
    notificationChannels[slackChannelId].config.url;

  // Webhook
  const webhookChannelId =
    notification_channels_enum_map && notification_channels_enum_map.WEBHOOKS;
  const webhookChannelURL =
    webhookChannelId &&
    notificationChannels[webhookChannelId] &&
    notificationChannels[webhookChannelId].config.url;

  // Email
  const emailChannelId = notification_channels_enum_map && notification_channels_enum_map.EMAIL;
  const emails =
    emailChannelId &&
    notificationChannels[emailChannelId] &&
    notificationChannels[emailChannelId].config.email;
  const notificationChannelsLoaded =
    !!notification_channels_enum_map && !request[GET_NOTIFICATIONS_CHANNEL_REQUEST];
  const currentUser = getCurrentUser(state);

  return {
    channelActionType,
    loadingSettings: !!request[GET_NOTIFICATIONS_SETTINGS_REQUEST],
    loadingChannelUpdate,
    manager: notificationsManager,
    slackChannelId,
    slackChannelURL,
    emailChannelId,
    emails,
    webhookChannelId,
    webhookChannelURL,
    notificationChannelsLoaded,
    currentUser,
  };
};

export default connect(mapStateToProps, {
  updateNotificationManager,
  loadNotificationsTypes,
  loadNotificationsChannels,
  loadNotificationsSettings,
  updateNotificationChannel,
  setContextualSupport,
  unsetContextualSupport,
})(NotificationsManager);
